import React from 'react';
import Style from './file.tailwind';
import { Icon, cn } from 'components/lib';
import { useTranslate } from 'app/translations';
import { formatFileName } from 'utilities/utils';

function fileHref(media) {
    if (!media.file_path) return undefined;
    return media.file_path.startsWith('http') ? media.file_path : `https://${media.file_path}`;
}

/**
 * @param compact  Inline chips for the always-visible context band, rather
 *                 than full-width stacked rows. Renders nothing when empty —
 *                 the band owns the combined empty state.
 * @param hideTitle  The band supplies its own heading.
 */
const TicketFile = ({ medias, compact, hideTitle }) => {
    const { _t } = useTranslate();

    if (compact && !medias?.length) return null;

    return (
        <div>
            {!hideTitle && (
                <h3 className={Style.title}>
                    <Icon
                        image="paperclip"
                        size={16}
                        color="currentColor"
                        className="text-text-muted"
                    />
                    {_t('ticket.history.file')}
                    {medias?.length > 1 ? 's' : ''}
                </h3>
            )}
            {medias?.length ? (
                <div className={compact ? Style.chips : Style.list}>
                    {medias.map((media, index) => (
                        <a
                            key={media.id || index}
                            target="_blank"
                            rel="noreferrer"
                            href={fileHref(media)}
                            className={cn(Style.row, compact && Style.chip)}
                            title={media.file?.original_name}>
                            <Icon
                                image="paperclip"
                                size={14}
                                color="currentColor"
                                className="shrink-0 text-text-muted"
                            />
                            <span className="truncate">
                                {formatFileName(media.file?.original_name || 'file')}
                            </span>
                        </a>
                    ))}
                </div>
            ) : (
                <div className={Style.empty}>
                    <Icon image="paperclip" size={14} color="currentColor" />
                    {_t('ticket.history.noFilesAttached')}
                </div>
            )}
        </div>
    );
};

export default TicketFile;
